import { createSlice } from '@reduxjs/toolkit';

const initData = {
  shipments: [],
  vehicles: [],
  output: {},
  errors: [],
};

const globalSlice = createSlice({
  name: 'global',
  initialState: initData,
  reducers: {
    setShipments: (state, action) => {
      const shipments = action.payload;
      state.errors = [];
      state.shipments = shipments;
    },
    setVehicles: (state, action) => {
      const vehicles = action.payload;
      state.errors = [];
      state.vehicles = vehicles;
    },
    setOutput: (state, action) => {
      const output = action.payload;
      state.output = output;
    },
    setErrors: (state, action) => {
      const errors = action.payload;
      state.errors = errors;
    },
    clearAll: (state) => {
      state.shipments = initData.shipments;
      state.vehicles = initData.vehicles;
      state.output = initData.output;
      state.errors = initData.errors;
    },
  },
});

export const { setShipments, setVehicles, setOutput, clearAll, setErrors } = globalSlice.actions;

export default globalSlice.reducer;
